import * as React from 'react';

import { FileUpload } from '../../../../packages/fileUpload/components/FileUpload';
import { useDropZone } from '../../../../packages/fileUpload/utils/useDropZone';
import {
  FileDropZone,
  FileUploadError,
  FileView,
} from '../../../../packages/fileUpload/components/FileUpload/components';
import { useSingleFilesUploadField } from './utils';
import { mapDocumentToFieldValue } from '../../../../packages/fileUpload/mappers';

export interface ISingleFilesUploadContainerProps {
  name: string;
}

export const SingleFilesUploadContainer: React.FC<ISingleFilesUploadContainerProps> = props => {
  const { isLoading, error, value, name, handleFileRemove, handleFileSelect, fileInputKey, touched } =
    useSingleFilesUploadField(props);

  const { showDropZone } = useDropZone({
    onFileDrop: handleFileSelect,
  });

  return (
    <>
      {value ? (
        <FileView value={mapDocumentToFieldValue(value)} onDelete={handleFileRemove} />
      ) : (
        <FileUpload
          key={fileInputKey}
          name={name}
          onFileSelect={handleFileSelect}
          isLoading={isLoading}
          buttonText="Выберите документ"
          descriptionText="или перетащите его в эту область"
        />
      )}

      {touched && error && <FileUploadError error={error} />}

      {!value && showDropZone && <FileDropZone />}
    </>
  );
};

SingleFilesUploadContainer.displayName = 'SingleFilesUploadContainer';
